// Doesnot changed variant images 

// Code by KA - START 


// (() => {
//   const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

//   const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
//   const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

//   // ---------------- Refresh Drawer + Bubble ----------------
//   async function refreshCartSections() {
//     try {
//       const url = `${ROOT}?sections=cart-drawer,cart-icon-bubble`;
//       const res = await fetch(url, { credentials: 'same-origin' });
//       if (res.ok) {
//         const json = await res.json();

//         // --- Update Drawer ---
//         if (json['cart-drawer']) {
//           const doc = parseHTML(json['cart-drawer']);
//           const newDrawer = doc.querySelector('cart-drawer');
//           const pageDrawer = document.querySelector('cart-drawer');
//           if (pageDrawer && newDrawer) {
//             pageDrawer.innerHTML = newDrawer.innerHTML;
//           }
//         }

//         // --- Update Bubble ---
//         if (json['cart-icon-bubble']) {
//           const doc = parseHTML(json['cart-icon-bubble']);
//           const newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('[data-cart-count]');
//           const pageBubble = document.querySelector('#cart-icon-bubble') || document.querySelector('[data-cart-count]');
//           if (pageBubble && newBubble) {
//             pageBubble.replaceWith(newBubble);
//           }
//         }
//       }
//     } catch (e) {
//       console.warn('Section refresh failed:', e);
//     }

//     try {
//       const cart = await fetchCart();
//       document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
//       document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
//       document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));

//       // --- Ensure drawer is visible ---
//       const drawer = document.querySelector('cart-drawer');
//       if (drawer) drawer.classList.add('is-open');
//     } catch (e) {
//       console.warn('Drawer open failed:', e);
//     }
//   }

// // Cart drawer open after add to cart is click - START 
//   async function openCartDrawer() {
//   const drawer = document.querySelector('cart-drawer');
//   const overlay = document.getElementById('CartDrawer-Overlay');

//   if (!drawer || !overlay) return;

//   // Ensure classes for animation & visibility
//   drawer.classList.add('active', 'animate');
//   drawer.classList.remove('is-empty'); // remove if cart has items
//   overlay.style.display = 'block';

//   // Optional: focus drawer for accessibility
//   const inner = drawer.querySelector('.drawer__inner');
//   if (inner) inner.focus({ preventScroll: true });

//   // Dispatch theme event if theme listens for it
//   document.dispatchEvent(new CustomEvent('theme:cart:opened'));
// }
// // Cart drawer open after add to cart is click - END

//   // ---------------- Per-section wiring ----------------
//   document.querySelectorAll('[data-vt-actions]').forEach(actions => {
//     const section   = actions.closest('[data-section-id]') || document;
//     const grid      = section.querySelector('[data-variant-tiles]'); 
//     const pricebar  = section.querySelector('[data-vt-pricebar]');
//     const sticky    = section.querySelector('[data-vt-sticky]');
//     const stickySel = sticky?.querySelector('[data-vt-sticky-variant]') || null;

//     let selectedVariantId = actions.dataset.defaultVid || null;

//     // ---------- Helpers ----------
//     function updateTopPriceFromTile(tile) {
//       if (!tile || !pricebar) return;
//       const now  = pricebar.querySelector('[data-vt-now]');
//       const was  = pricebar.querySelector('[data-vt-was]');
//       const save = pricebar.querySelector('[data-vt-save]');

//       now.textContent = tile.dataset.price;
//       const compareCents = parseInt(tile.dataset.compareCents || '0', 10);
//       const savingCents  = parseInt(tile.dataset.savingCents  || '0', 10);

//       if (compareCents > 0 && savingCents > 0) {
//         was.style.display = '';
//         was.textContent = tile.dataset.compare;
//         save.style.display = '';
//         save.textContent = `Save ${tile.dataset.saving}`;
//       } else {
//         was.style.display = 'none';
//         save.style.display = 'none';
//       }
//     }

//     function setActiveTileById(vid) {
//       if (!grid) return;
//       grid.querySelectorAll('.variant-tile').forEach(el => {
//         const isActive = el.getAttribute('data-variant-id') === String(vid);
//         el.classList.toggle('is-active', isActive);
//         el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
//         if (isActive) updateTopPriceFromTile(el);
//       });
//     }

//     function selectVariant(vid) {
//       selectedVariantId = String(vid);
//       setActiveTileById(selectedVariantId);
//       if (stickySel) stickySel.value = selectedVariantId;
//     }

//      // ---------- Init selection ----------
//     (function initSelection(){
//       const initialTile = grid?.querySelector('.variant-tile.is-active') || grid?.querySelector('.variant-tile');
//       if (initialTile) {
//         selectedVariantId = initialTile.getAttribute('data-variant-id');
//         updateTopPriceFromTile(initialTile);
//       }
//       if (stickySel && selectedVariantId) stickySel.value = selectedVariantId;
//     })();

//     // Tile click
//     if (grid) {
//       grid.addEventListener('click', e => {
//         const tile = e.target.closest('.variant-tile');
//         if (!tile || tile.getAttribute('aria-disabled') === 'true') return;
//         selectVariant(tile.getAttribute('data-variant-id'));
//       });
//     }

//     // Sticky select
//     stickySel?.addEventListener('change', e => {
//       const vid = e.target.value;
//       if (vid) selectVariant(vid);
//     });

//     // ---------- Qty + ATC ----------
//     function wireAtc(scope) {
//       if (!scope) return;
//       const qtyInput = scope.querySelector('[data-vt-qty]');
//       const minusBtn = scope.querySelector('[data-vt-minus]');
//       const plusBtn  = scope.querySelector('[data-vt-plus]');
//       const atcBtn   = scope.querySelector('[data-vt-atc]');

//       minusBtn?.addEventListener('click', () => {
//         const current = parseInt(qtyInput.value || '1', 10);
//         qtyInput.value = Math.max(1, current - 1);
//       });
//       plusBtn?.addEventListener('click', () => {
//         const current = parseInt(qtyInput.value || '1', 10);
//         qtyInput.value = current + 1;
//       });

      
//       //  Update the cart bubble count by- START
//       atcBtn?.addEventListener('click', async () => {
//         const qty = parseInt(qtyInput?.value || '1', 10);
//         const vid = selectedVariantId || grid?.querySelector('.variant-tile.is-active')?.getAttribute('data-variant-id');
//         if (!vid) return;
//         atcBtn.disabled = true;
//         const prevLabel = atcBtn.textContent;
//         atcBtn.textContent = 'Adding…';
//         try {
//           const res = await fetch('/cart/add.js', {
//             method: 'POST',
//             credentials: 'same-origin',
//             headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//             body: JSON.stringify({ id: Number(vid), quantity: qty })
//           });
//           if (!res.ok) {
//             const err = await res.json().catch(() => ({}));
//             throw new Error(err?.description || 'Add to cart failed');
//           }

//           // Refresh cart drawer and bubble
//           await refreshCartSections();

//           // Open cartdrawer after add to cart button clicks
//           await openCartDrawer();

//           // Open drawer using theme event
//           // document.dispatchEvent(new CustomEvent('cart:open'));

//           // Update cart bubble manually in case AJAX snippet fails
//           const cart = await fetch('/cart.js').then(r => r.json());
//           const bubble = document.getElementById('cart-icon-bubble');
//           if (bubble) bubble.textContent = cart.item_count;

//           // Ensure drawer is open
//           const drawer = document.querySelector('cart-drawer');
//           if (drawer) drawer.classList.add('is-open');
//         } catch (e) {
//           console.error(e);
//           alert(e.message || 'Could not add to cart');
//         } finally {
//           atcBtn.disabled = false;
//           atcBtn.textContent = prevLabel;
//         }
//       });
// // Need to update the cart bubble count - END 

//     }

//     wireAtc(actions);
//     wireAtc(sticky);

//     // Sticky show/hide
//     if (sticky && actions) {
//       const headerOffset = parseInt(document.body.dataset.vtStickyOffset || '0', 10);
//       const updateSticky = () => {
//         const top = actions.getBoundingClientRect().top;
//         const shouldShow = top <= headerOffset;
//         sticky.classList.toggle('is-visible', shouldShow);
//       };
//       sticky.classList.remove('is-visible');
//       updateSticky();
//       window.addEventListener('scroll', updateSticky, { passive: true });
//       window.addEventListener('resize', updateSticky);
//       document.addEventListener('DOMContentLoaded', updateSticky);
//     }
//   });
// })();



// Variant Image changed 


(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

  // ---------------- Refresh Drawer + Bubble ----------------
  async function refreshCartSections() {
    try {
      const url = `${ROOT}?sections=cart-drawer,cart-icon-bubble`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (res.ok) {
        const json = await res.json();

        // --- Update Drawer ---
        if (json['cart-drawer']) {
          const doc = parseHTML(json['cart-drawer']);
          const newDrawer = doc.querySelector('cart-drawer');
          const pageDrawer = document.querySelector('cart-drawer');
          if (pageDrawer && newDrawer) {
            pageDrawer.innerHTML = newDrawer.innerHTML;
          }
        }

        // --- Update Bubble ---
        if (json['cart-icon-bubble']) {
          const doc = parseHTML(json['cart-icon-bubble']);
          const newBubble = doc.querySelector('#cart-icon-bubble') || doc.querySelector('[data-cart-count]');
          const pageBubble = document.querySelector('#cart-icon-bubble') || document.querySelector('[data-cart-count]');
          if (pageBubble && newBubble) {
            pageBubble.replaceWith(newBubble);
          }
        }
      }
    } catch (e) {
      console.warn('Section refresh failed:', e);
    }

    try {
      const cart = await fetchCart();
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart } }));

      // --- Ensure drawer is visible ---
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.add('is-open');
    } catch (e) {
      console.warn('Drawer open failed:', e);
    }
  }

// Cart drawer open after add to cart is click - START 
  async function openCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');

  if (!drawer || !overlay) return;

  // Ensure classes for animation & visibility
  drawer.classList.add('active', 'animate');
  drawer.classList.remove('is-empty'); // remove if cart has items
  overlay.style.display = 'block';

  // Optional: focus drawer for accessibility
  const inner = drawer.querySelector('.drawer__inner');
  if (inner) inner.focus({ preventScroll: true });

  // Dispatch theme event if theme listens for it
  document.dispatchEvent(new CustomEvent('theme:cart:opened'));
}
// Cart drawer open after add to cart is click - END

  // ---------------- Per-section wiring ----------------
  document.querySelectorAll('[data-vt-actions]').forEach(actions => {
    const section   = actions.closest('[data-section-id]') || document;
    const grid      = section.querySelector('[data-variant-tiles]'); 
    const pricebar  = section.querySelector('[data-vt-pricebar]');
    const sticky    = section.querySelector('[data-vt-sticky]');
    const stickySel = sticky?.querySelector('[data-vt-sticky-variant]') || null;

    let selectedVariantId = actions.dataset.defaultVid || null;

    // ---------- Helpers ----------
    function updateTopPriceFromTile(tile) {
      if (!tile || !pricebar) return;
      const now  = pricebar.querySelector('[data-vt-now]');
      const was  = pricebar.querySelector('[data-vt-was]');
      const save = pricebar.querySelector('[data-vt-save]');

      now.textContent = tile.dataset.price;
      const compareCents = parseInt(tile.dataset.compareCents || '0', 10);
      const savingCents  = parseInt(tile.dataset.savingCents  || '0', 10);

      if (compareCents > 0 && savingCents > 0) {
        was.style.display = '';
        was.textContent = tile.dataset.compare;
        save.style.display = '';
        save.textContent = `Save ${tile.dataset.saving}`;
      } else {
        was.style.display = 'none';
        save.style.display = 'none';
      }
    }

    function setActiveTileById(vid) {
      if (!grid) return;
      grid.querySelectorAll('.variant-tile').forEach(el => {
        const isActive = el.getAttribute('data-variant-id') === String(vid);
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) updateTopPriceFromTile(el);
      });
    }

    function selectVariant(vid) {
      selectedVariantId = String(vid);
      setActiveTileById(selectedVariantId);
      if (stickySel) stickySel.value = selectedVariantId;
    }

     // ---------- Init selection ----------
    (function initSelection(){
      const initialTile = grid?.querySelector('.variant-tile.is-active') || grid?.querySelector('.variant-tile');
      if (initialTile) {
        selectedVariantId = initialTile.getAttribute('data-variant-id');
        updateTopPriceFromTile(initialTile);
      }
      if (stickySel && selectedVariantId) stickySel.value = selectedVariantId;
    })();

    // Tile click
    // if (grid) {
    //   grid.addEventListener('click', e => {
    //     const tile = e.target.closest('.variant-tile');
    //     if (!tile || tile.getAttribute('aria-disabled') === 'true') return;
    //     selectVariant(tile.getAttribute('data-variant-id'));
    //   });
    // }

    // ---- Replace your existing "Tile click" block with this ----
if (grid) {
  grid.addEventListener('click', e => {
    const tile = e.target.closest('.variant-tile');
    if (!tile || tile.getAttribute('aria-disabled') === 'true') return;

    const vid = tile.getAttribute('data-variant-id');
    if (!vid) return;

    // 1) Perform your existing selection logic (updates UI/prices)
    selectVariant(vid);

    // 2) Try to find and set the Shopify hidden select[name="id"]
    const wrapper = tile.closest('form, .product-single, [data-section-id], [data-product-id]') || document;
    const select = wrapper.querySelector('select[name="id"]') || document.querySelector('select[name="id"]');

    // if (select) {
    //   // set the select and trigger change so slate.Variants handles image + SKU + history
    //   if (select.value !== String(vid)) {
    //     select.value = String(vid);
    //     if (window.jQuery) {
    //       window.jQuery(select).trigger('change');
    //     } else {
    //       select.dispatchEvent(new Event('change', { bubbles: true }));
    //     }
    //     console.log('variant-tile: set select[name="id"] to', vid);
    //   } else {
    //     // still trigger change in case handlers need re-run
    //     if (window.jQuery) {
    //       window.jQuery(select).trigger('change');
    //     } else {
    //       select.dispatchEvent(new Event('change', { bubbles: true }));
    //     }
    //     console.log('variant-tile: select already set — triggered change for', vid);
    //   }
    //   return; // let slate.Variants handle image change if needed
    // }


    if (select) {
  // update value
  if (select.value !== String(vid)) {
    select.value = String(vid);
    console.log('variant-tile: set select[name="id"] to', vid);
  } else {
    console.log('variant-tile: select already set — retriggering change for', vid);
  }

  // trigger change (theme / slate.Variants might be listening)
  const evt = new Event('change', { bubbles: true, cancelable: true });
  select.dispatchEvent(evt);
  if (window.jQuery) {
    window.jQuery(select).trigger('change');
  }

  // fallback: update product image(s) directly
const variant = window.meta?.product?.variants.find(v => String(v.id) === String(vid));
if (variant && variant.featured_image) {
  // Try multiple selectors since themes differ
  const mainImg = document.querySelector('.product__media img, .product-gallery img, .product-single__photo img');

  if (mainImg) {
    mainImg.src = variant.featured_image.src;
    mainImg.srcset = variant.featured_image.src; // in case srcset is used
    mainImg.alt = variant.featured_image.alt || '';
    console.log('variant-tile: manually swapped main image to', variant.featured_image.src);
  } else {
    console.warn('variant-tile: could not find product image element to swap');
  }
}


  return;
}


    // 3) Fallback: no select found — emulate variantImageChange directly
    const productObj = (window.meta && window.meta.product) || window.product || window.Product || null;
    let variant = null;
    if (productObj && Array.isArray(productObj.variants)) {
      variant = productObj.variants.find(v => String(v.id) === String(vid)) || null;
    }

    // choose the main image element (try several common selectors)
    const mainImg = wrapper.querySelector('.product-main-image img, .product-single__photo img, img.product-featured') ||
                    document.querySelector('.product-main-image img, .product-single__photo img, img.product-featured');
    const currentSrc = mainImg ? mainImg.src : null;
    const newSrc = (variant && variant.featured_image && variant.featured_image.src) ? variant.featured_image.src : null;

    if (newSrc && newSrc !== currentSrc) {
      console.log('variant-tile: dispatching fallback variantImageChange for', vid);

      // jQuery-style event (matches slate.Variants trigger shape)
      if (window.jQuery) {
        window.jQuery(document).trigger({ type: 'variantImageChange', variant: variant || { id: vid } });
      }

      // DOM CustomEvent (for any listeners using addEventListener)
      try {
        document.dispatchEvent(new CustomEvent('variantImageChange', { detail: { variant: variant || { id: vid } } }));
      } catch (err) {
        // older browsers may not support CustomEvent constructor
        console.warn('variant-tile: CustomEvent dispatch failed', err);
      }

      // also update image as a last-resort fallback
      if (mainImg) {
        mainImg.src = newSrc;
        if (variant && variant.featured_image && variant.featured_image.alt) mainImg.alt = variant.featured_image.alt;
      } else {
        const bgHolder = wrapper.querySelector('.product-single__photo, .product-main-image');
        if (bgHolder) bgHolder.style.backgroundImage = 'url("' + newSrc + '")';
      }
    } else {
      console.log('variant-tile: no image change required or no variant image available for', vid);
    }
  });
}


    // Sticky select
    stickySel?.addEventListener('change', e => {
      const vid = e.target.value;
      if (vid) selectVariant(vid);
    });

    // ---------- Qty + ATC ----------
    function wireAtc(scope) {
      if (!scope) return;
      const qtyInput = scope.querySelector('[data-vt-qty]');
      const minusBtn = scope.querySelector('[data-vt-minus]');
      const plusBtn  = scope.querySelector('[data-vt-plus]');
      const atcBtn   = scope.querySelector('[data-vt-atc]');

      minusBtn?.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, current - 1);
      });
      plusBtn?.addEventListener('click', () => {
        const current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = current + 1;
      });

      
      //  Update the cart bubble count by- START
      atcBtn?.addEventListener('click', async () => {
        const qty = parseInt(qtyInput?.value || '1', 10);
        const vid = selectedVariantId || grid?.querySelector('.variant-tile.is-active')?.getAttribute('data-variant-id');
        if (!vid) return;

        const modal = document.getElementById('towel-color-modal');
        let selectedTowel = null;
        if (modal) {
          const activeItem = modal.querySelector('.towel-modal-item.is-active');
          if (activeItem) {
            selectedTowel = activeItem.getAttribute('data-towel-title');
          }
          if (!selectedTowel) {
            modal.style.display = 'flex';
            const confirmBtn = modal.querySelector('.towel-modal-confirm-btn');
            const onConfirm = () => {
              confirmBtn.removeEventListener('click', onConfirm);
              atcBtn.click();
            };
            confirmBtn.addEventListener('click', onConfirm);
            return;
          }
        }

        const discountCode = scope.getAttribute('data-discount-code');

        atcBtn.disabled = true;
        const prevLabel = atcBtn.textContent;
        atcBtn.textContent = 'Adding…';
        try {
          if (discountCode) {
            await fetch(`/discount/${discountCode}`).catch(() => {});
          }

          const addBody = { id: Number(vid), quantity: qty };
          if (selectedTowel) {
            addBody.properties = {
              "Towel Color": selectedTowel
            };
          }

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(addBody)
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err?.description || 'Add to cart failed');
          }

          // Refresh cart drawer and bubble
          await refreshCartSections();

          // Open cartdrawer after add to cart button clicks
          await openCartDrawer();

          // Open drawer using theme event
          // document.dispatchEvent(new CustomEvent('cart:open'));

          // Update cart bubble manually in case AJAX snippet fails
          const cart = await fetch('/cart.js').then(r => r.json());
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.textContent = cart.item_count;

          // Ensure drawer is open
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.classList.add('is-open');
        } catch (e) {
          console.error(e);
          alert(e.message || 'Could not add to cart');
        } finally {
          atcBtn.disabled = false;
          atcBtn.textContent = prevLabel;
        }
      });
// Need to update the cart bubble count - END 

    }

    wireAtc(actions);
    wireAtc(sticky);

    // Sticky show/hide
    if (sticky && actions) {
      const headerOffset = parseInt(document.body.dataset.vtStickyOffset || '0', 10);
      const updateSticky = () => {
        const top = actions.getBoundingClientRect().top;
        const shouldShow = top <= headerOffset;
        sticky.classList.toggle('is-visible', shouldShow);
      };
      sticky.classList.remove('is-visible');
      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      document.addEventListener('DOMContentLoaded', updateSticky);
    }
  });
})();


document.addEventListener("variant:changed", function(e) {
  const variant = e.detail.variant;
  if (!variant || !variant.featured_media) return;

  const mediaId = variant.featured_media.id;
  const swiperEl = document.querySelector(".primgSlider.swiper");
  if (!swiperEl || !swiperEl.swiper) return;

  const swiperInstance = swiperEl.swiper;

  const targetIndex = Array.from(swiperEl.querySelectorAll(".swiper-slide")).findIndex(
    slide => slide.getAttribute("data-id") == mediaId
  );

  if (targetIndex > -1) {
    swiperInstance.slideToLoop(targetIndex);
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const select = document.querySelector('form[action*="/cart/add"] select[name="id"]');
  if (!select || !window.meta || !window.meta.product) return;

  // Build map: variant.id → featured_media.id
  const variantImageMap = {};
  window.meta.product.variants.forEach(v => {
    if (v.featured_media) {
      variantImageMap[v.id] = v.featured_media.id;
    }
  });

  // Watch for changes on variant select
  select.addEventListener("change", function() {
    const variantId = select.value;
    const mediaId = variantImageMap[variantId];

    console.log("Variant selected:", variantId, "→ mediaId:", mediaId);

    if (mediaId) {
      updateSwiperToMedia(mediaId);
    }
  });

  function updateSwiperToMedia(mediaId) {
    const swiperEl = document.querySelector(".primgSlider.swiper");
    if (!swiperEl || !swiperEl.swiper) return;

    const swiperInstance = swiperEl.swiper;
    const targetIndex = Array.from(swiperEl.querySelectorAll(".swiper-slide")).findIndex(
      slide => slide.getAttribute("data-id") == mediaId
    );

    console.log("Trying to slide to mediaId:", mediaId, "at index:", targetIndex);

    if (targetIndex > -1) {
      swiperInstance.slideToLoop(targetIndex);
    }
  }
});


